import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { Agency } from "../../shared/types/agency";
import { HubAgenciesService } from "../../shared/services/hub-agencies.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationService } from "../../shared/services/notification.service";
import { Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { ROLES } from "../../shared/constants";
import { HelpersService } from "../../shared/services/helpers.service";
import { ErrorAlert } from "../../shared/models/error-alert";
import { TranslateService } from "@ngx-translate/core";
import {RESPONSE_OK} from "../../shared/types/system";

@Component({
  selector: "app-subagencies",
  templateUrl: "./subagencies.component.html",
  styleUrls: ["./subagencies.component.scss"],
})
export class SubagenciesComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  agencies: Agency[] = [];
  agencyError: ErrorAlert = new ErrorAlert();
  errors = {
    email: "",
    agency: "",
    error: { summary: "" },
  };
  model: any = {};
  loaded: boolean;

  constructor(
    public hubAgenciesService: HubAgenciesService,
    public modalService: NgbModal,
    private _notificationSvc: NotificationService,
    private router: Router,
    private helpers: HelpersService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loadSubagencies();
  }

  loadSubagencies() {
    this.loaded = false;
    this.hubAgenciesService
      .getAll()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.agencies = res.body;
          }
        },
        (err) =>
          this._notificationSvc.error(
            this.translate.instant("NOTIFICATIONS.ERROR"),
            this.translate.instant(
              "SUBAGENCY_LIST.NOTIFICATIONS.FAILED_LOAD_AGENCIES",
            ),
          ),
        () => (this.loaded = true),
      );
  }

  addNewSubagency(content) {
    this.modalService.open(content).result.then(
      (result) => { },
      (reason) => { },
    );
  }

  deactivateAgency(id: string) {
    this.hubAgenciesService
      .deactivateAgency({ id: id })
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        (response: any) => {
          let res = response.body;
          if (res.status === RESPONSE_OK) {
            this._notificationSvc.success(
              this.translate.instant("NOTIFICATIONS.SUCCESS"),
              this.translate.instant(
                "SUBAGENCY_LIST.NOTIFICATIONS.AGENCY_REMOVED",
                { id },
              ),
              0,
            );
            this.ngOnInit();
          } else {
            this.errors = res;
          }
        },
        (err) =>
          this._notificationSvc.error(
            err.error?.status,
            err.error?.error,
            err.status,
          ),
      );
  }

  save(c) {
    let body = { ...this.model };
    this.hubAgenciesService
      .addAgency(body)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        (response: any) => {
          let res = response.body;
          if (res.status === RESPONSE_OK) {
            this._notificationSvc.success(
              this.translate.instant("NOTIFICATIONS.SUCCESS"),
              this.translate.instant(
                "SUBAGENCY_LIST.NOTIFICATIONS.AGENCY_ADDED",
                { name: this.model.name },
              ),
              0,
            );
            c("ok");
            this.ngOnInit();
          } else {
            this.errors = res;
          }
        },
        (error) => (this.agencyError = this.helpers.getError(error)),
      );
  }

  getNumberOfRoles(agency: Agency, role: string) {
    let count = 0;
    if (role === ROLES.MANAGER) {
      count = agency?.accounts?.filter(
        (accountRole) =>
          accountRole.role === ROLES.MANAGER ||
          accountRole.role === ROLES.SUBAGENCY_MANAGER,
      ).length;
    } else {
      count = agency?.accounts?.filter(
        (accountRole) =>
          accountRole.role !== ROLES.MANAGER &&
          accountRole.role !== ROLES.SUBAGENCY_MANAGER,
      ).length;
    }
    return count || "-";
  }

  view(url: string) {
    this.router.navigateByUrl(`agencies/${url}`);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
